export default __webpack_public_path__ + "static/media/class_vii_viii_ix_m.af3d86be.png";